import EventEmitter from "./EventEmitter.js";

export default class Time extends EventEmitter
{
    constructor()
    {
        super();
        console.log("Created Time.");
        this.Start = Date.now();
        this.Current = this.Start;
        this.Elapsed = 0;
        this.Delta = 16;

        // call tick() on the next frame
        window.requestAnimationFrame(() => { this.tick(); });
    }

    tick() {
        const previousTime = this.Current;
        this.Current = Date.now();
        this.Delta = this.Current - previousTime;

        this.trigger('tick');

        //console.log(this.Delta);
        window.requestAnimationFrame(() => { this.tick(); });
    }
}